// 画面に出す失敗の文。英語や内部コードは出さない（旧 userMessageForError の方針: 2026-09-06 Ryu）。
// サーバーが日本語の文を返したときだけ、その文を使う。

const JA = /[぀-ヿ一-鿿]/;

export function hasJapanese(s: string | undefined | null): boolean {
  return !!s && JA.test(s);
}

/** API の失敗（status 0 は通信できなかった）を日本語の文にする */
export function apiErrorMessage(status: number, code?: string, serverMessage?: string): string {
  if (status === 0) return 'サーバーにつながりませんでした。通信状況を確かめて、もう一度お試しください。';
  if (status === 401) return 'ログインの有効期限が切れました。もう一度ログインしてください。';
  if (hasJapanese(serverMessage)) return serverMessage!;
  if (status === 403) return 'この操作をする権限がありません。';
  if (status === 404) return '対象が見つかりませんでした。';
  if (status === 409 || code === 'CONFLICT') return 'ほかの操作と重なりました。画面を読み込み直してください。';
  if (status === 400 || code === 'VALIDATION_ERROR') return '入力内容を確かめてください。';
  if (status >= 500) return 'サーバーで問題が起きました。時間をおいてもう一度お試しください。';
  return '処理に失敗しました。もう一度お試しください。';
}

/** Cognito の失敗（__type）を日本語の文にする */
export function cognitoErrorMessage(type: string | undefined): string {
  const t = (type ?? '').split('#').pop() ?? '';
  switch (t) {
    case 'NotAuthorizedException':
      return 'ログインリンクが無効か、有効期限が切れています。もう一度リンクを送ってください。';
    case 'UserNotFoundException':
      return 'このメールアドレスは登録されていません。管理者に招待を依頼してください。';
    case 'CodeMismatchException':
    case 'ExpiredCodeException':
      return 'ログインリンクの有効期限が切れています。もう一度リンクを送ってください。';
    case 'TooManyRequestsException':
    case 'LimitExceededException':
      return '短い時間に操作が重なりました。少し待ってからお試しください。';
    case 'UserLambdaValidationException':
      return 'ログインの準備に失敗しました。もう一度リンクを送ってください。';
    case 'NETWORK':
      return 'サーバーにつながりませんでした。通信状況を確かめて、もう一度お試しください。';
    default:
      return 'ログインに失敗しました。もう一度お試しください。';
  }
}

/** 例外から画面用の文を取り出す（ApiError / AuthError は message が日本語） */
export function messageOf(e: unknown): string {
  if (e && typeof e === 'object' && 'userMessage' in e && typeof (e as { userMessage: unknown }).userMessage === 'string') {
    return (e as { userMessage: string }).userMessage;
  }
  if (e instanceof Error && hasJapanese(e.message)) return e.message;
  return '処理に失敗しました。もう一度お試しください。';
}
